/* eslint-disable jsx-a11y/alt-text */
import React from 'react';

interface IProperties {
  className?: string;
}

const ProductNewIcon = ({ className }: IProperties) => {
  return (
    <svg width="43" height="48" viewBox="0 0 43 48" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M31.5088 19.9183L15.5567 11.3804C15.1967 11.1893 14.7953 11.0894 14.3877 11.0894C13.9801 11.0894 13.5787 11.1893 13.2187 11.3804L8.50417 13.8346C8.07907 14.0675 7.72344 14.4092 7.47358 14.8245C7.22373 15.2399 7.08862 15.7142 7.08205 16.1989C7.07549 16.6836 7.1977 17.1613 7.4362 17.5833C7.67471 18.0053 8.02096 18.3564 8.43958 18.6008L24.2238 27.5521C24.6071 27.7647 25.0383 27.8763 25.4767 27.8763C25.915 27.8763 26.3462 27.7647 26.7296 27.5521L31.625 24.6587C32.035 24.4082 32.3719 24.0542 32.6018 23.6323C32.8316 23.2103 32.9465 22.7353 32.9347 22.255C32.9229 21.7746 32.7849 21.3059 32.5346 20.8957C32.2844 20.4855 31.9305 20.1485 31.5088 19.9183Z"
        stroke="#020053"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M8.49124 19.9183L24.4433 11.3804C24.8033 11.1893 25.2047 11.0894 25.6123 11.0894C26.0199 11.0894 26.4212 11.1893 26.7812 11.3804L31.4958 13.8346C31.9243 14.0617 32.2849 14.3985 32.5405 14.8105C32.7962 15.2226 32.9379 15.6952 32.951 16.18C32.9641 16.6648 32.8483 17.1444 32.6153 17.5697C32.3823 17.9951 32.0406 18.3509 31.625 18.6008L15.7762 27.5521C15.3929 27.7647 14.9617 27.8763 14.5233 27.8763C14.0849 27.8763 13.6538 27.7647 13.2704 27.5521L8.37499 24.6587C7.96499 24.4082 7.62813 24.0542 7.39824 23.6323C7.16835 23.2103 7.05353 22.7353 7.06531 22.255C7.07709 21.7746 7.21505 21.3059 7.46535 20.8957C7.71564 20.4855 8.06945 20.1485 8.49124 19.9183Z"
        stroke="#020053"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path d="M20 36.9167V25.2917" stroke="#020053" strokeLinecap="round" strokeLinejoin="round" />
      <path
        d="M30.3333 25.9375V30.2904C30.3338 30.778 30.2004 31.2563 29.9475 31.6731C29.6947 32.09 29.3322 32.4293 28.8996 32.6542L21.1496 36.6325C20.7945 36.817 20.4002 36.9134 20 36.9134C19.5998 36.9134 19.2055 36.817 18.8504 36.6325L11.1004 32.6542C10.6678 32.4293 10.3053 32.09 10.0525 31.6731C9.79962 31.2563 9.66617 30.778 9.66667 30.2904V25.9375"
        stroke="#020053"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};

export default ProductNewIcon;
